import { useTrackActions } from "@/utils/hooks/useTracking";
import { AnalyticsTrackingEvent } from "@brandclub/common-ui";
import { styled } from "@mui/material";
import { useCheckoutUI } from "../../CheckoutUIProvider";
import { useCheckoutCartInfo } from "../../hooks/useCheckoutCartInfo";
import { CheckoutIntent } from "../../types/CheckoutIntent";
import { useEffect, useState } from "react";

const UnderlinedButton = styled("button")(({ theme, disabled }) => ({
  background: "none",
  border: "none",
  padding: 0,
  font: "inherit",
  cursor: disabled ? "not-allowed" : "pointer",
  textDecoration: "underline",
  color: disabled
    ? theme.vars.palette.text.disabled
    : theme.vars.palette.primary.main,
  fontSize: "16px",
  fontWeight: 500,
  opacity: disabled ? 0.6 : 1,
  "&:hover": {
    textDecoration: disabled ? "underline" : "none",
  },
  "&:focus": {
    outline: `2px solid ${theme.vars.palette.primary.main}`,
    outlineOffset: "2px",
  },
}));

export const SubmitGuestCheckoutButton = ({
  text = "Submit guest order",
}: {
  text?: string;
}) => {
  const [state, send] = useCheckoutUI();
  const [trackAction] = useTrackActions();
  // @ts-ignore
  const { checkoutIntent } = state.context as {
    checkoutIntent: CheckoutIntent;
  };
  const checkoutIntentId = checkoutIntent?.checkoutIntentId;
  const { items } = useCheckoutCartInfo();
  const [canPlaceOrder, setCanPlaceOrder] = useState(false);

  const showEnabledSubmitButton =
    state.value === "ready_to_checkout" || state.value === "checking_out";

  const checkingOut = state.value === "checking_out";

  useEffect(() => {
    if (
      checkoutIntent?.shippingAddress?.address1 &&
      checkoutIntent?.stripePaymentMethod?.id &&
      checkoutIntent?.stripePaymentIntent?.id &&
      checkoutIntent?.retailerConnection?.username &&
      state.value === "ready_to_checkout"
    ) {
      setCanPlaceOrder(true);
    } else {
      setCanPlaceOrder(false);
    }
  }, [checkoutIntent, state.value]);

  const handleSubmitClick = () => {
    trackAction(AnalyticsTrackingEvent.CHECKOUT_GUEST_ORDER_SUBMIT, {
      checkoutIntentId: checkoutIntentId,
      checkoutItems: items || [],
      estimatedTotal: checkoutIntent?.estimatedOrderSummary?.total,
      checkoutPhase: "pre_submission",
    });
    send({ type: "SUBMIT_GUEST_CHECKOUT" });
  };

  if (!showEnabledSubmitButton || checkingOut) {
    return null;
  }

  return (
    <UnderlinedButton
      disabled={!canPlaceOrder}
      onClick={handleSubmitClick}
      type="button"
    >
      {text}
    </UnderlinedButton>
  );
};
